import React from 'react';
import PropTypes from 'prop-types';
import DatePicker, { registerLocale } from 'react-datepicker';
import { Icon, Text } from '../';
import 'react-datepicker/src/stylesheets/datepicker.scss';
import { fr } from 'date-fns/locale';
registerLocale('en-gb', fr);

AtomDatePicker.defaultProps = {
  className: '',
  placeholder: 'Date',
  minDate: null,
  locale: 'en-gb',
  dateFormat: 'dd/MM/yyyy',
  filterDate: null,
  onChange: null,
  isInvalid: false,
  isValid: false,
  selectsRange: true,
  size: 'meduim',
  selected: null,
  startDate: null,
  endDate: null,
  renderIcon: true,
  containerClassName: '',
  labelClassName: 'default-label',
  inputLabel: null,
  iconClassName: 'icon-date-picker'
};
AtomDatePicker.PropTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  minDate: PropTypes.any,
  locale: PropTypes.string,
  dateFormat: PropTypes.string,
  filterDate: PropTypes.any,
  onChange: PropTypes.any,
  isInvalid: PropTypes.bool,
  isValid: PropTypes.bool,
  selectsRange: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'meduim', 'larg']),
  selected: PropTypes.any,
  startDate: PropTypes.any,
  endDate: PropTypes.any,
  renderIcon: PropTypes.bool,
  containerClassName: PropTypes.string
};
function AtomDatePicker(props) {
  let className = '';
  let containerClassName = "container-date-picker "
  className = 'default-input '
  if (props.isInvalid === true) {
    className += ' invalid-input';
  }
  if (props.isValid === true) {
    className += ' valid-input';
  }
  if (props.size === 'meduim') {
    className += ' defaul-meduim-input ';
    containerClassName += ' defaul-meduim-input ';
  }
  if (props.size === 'larg') {
    className += ' defaul-larg-input ';
    containerClassName += ' defaul-larg-input ';
  }
  if (props.size === 'small') {
    className += ' defaul-small-input ';
    containerClassName += ' defaul-small-input ';
  }
  if (props.containerClassName) {
    containerClassName += props.containerClassName
  }
  className += props.className
  function renderIcon() {
      return <Icon
        icon='Calender'
        size={"16px"}
        className={props.iconClassName}
      />
  }
  function viewLabel() {
      return (props.inputLabel !== null)
        ? <Text className={props.labelClassName} text={props.inputLabel} />
        : null
  }
  console.log("SELECTED", props.selected)
  return (
    <div className={containerClassName}>
      {viewLabel()}
      <DatePicker
        disabled={props.disabled}
        locale={props.locale}
        selected={props.selected && props.selected}
        startDate={props.startDate}
        endDate={props.endDate}
        onChange={props.onChange}
        className={className}
        minDate={props.minDate}
        maxDate={props.maxDate}
        placeholderText={props.placeholder}
        filterDate={props.filterDate}
        dateFormat={props.dateFormat}
        selectsRange={props.selectsRange}
      />
      {props.renderIcon && renderIcon()}
    </div>
  );
}

export default AtomDatePicker;
